<script>
	import { onMount } from 'svelte';
	import { injectGlobalStyles } from './shared.js';
	import { fetchLeaderboard } from './betting.js';
	import Loader from './Loader.svelte';

	export let projectId = '';
	export let start = '';
	export let end = '';
	export let title = 'Конкурс прогнозов';

	let host;
	let items = [];
	let loading = false;
	let errorMessage = '';

	onMount(() => {
		const root = host?.getRootNode();
		if (root instanceof ShadowRoot) injectGlobalStyles(root);
		void load();
	});

	function defaultRange() {
		return {
			start: start || '2000-01-01T00:00:00.000Z',
			end: end || '2100-01-01T00:00:00.000Z'
		};
	}

	async function load() {
		if (!projectId) {
			items = [];
			return;
		}

		loading = true;
		errorMessage = '';
		try {
			const range = defaultRange();
			items = await fetchLeaderboard({
				projectId,
				start: range.start,
				end: range.end
			});
		} catch (error) {
			console.error('Load leaderboard error:', error);
			errorMessage = 'Ошибка загрузки таблицы лидеров';
		} finally {
			loading = false;
		}
	}

	function medalFor(rank) {
		if (rank === 1) return 'gold';
		if (rank === 2) return 'silver';
		if (rank === 3) return 'bronz';
		return null;
	}

	function getInitials(value) {
		const parts = String(value || '').trim().split(/\s+/).filter(Boolean);
		if (!parts.length) return '?';
		if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
		return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
	}

	function getNet(item) {
		return (Number(item?.wins) || 0) - (Number(item?.losses) || 0);
	}
</script>

<div class="bettings-leaderboard" bind:this={host}>
	{#if loading}
		<div class="bettings-leaderboard__status"><Loader size="48px" /></div>
	{:else if errorMessage}
		<div class="bettings-leaderboard__status">{errorMessage}</div>
	{:else}
		<section class="predictions">
			<div class="container">
				<div class="headline">
					<h2 class="predictions__title">{title}</h2>
				</div>

				<div class="filter-wrap">
					<div class="table__wrap">
						<table class="table">
							<thead>
								<tr>
									<th class="table__cell--sm">Место</th>
									<th>Игрок</th>
									<th>W</th>
									<th>L</th>
									<th>+/-</th>
									<th>%</th>
								</tr>
							</thead>
							<tbody>
								{#each items as item}
									{@const medal = medalFor(item?.rank)}
									<tr>
										<td>
											{#if medal}
												<svg class="ic" aria-hidden="true">
													<use href="img/ic.svg#{medal}"></use>
												</svg>
											{:else}
												<div class="predictions__place">{item.rank}</div>
											{/if}
										</td>
										<td>
											<div class="table__item">
												{#if item.user?.image}
													<img src={item.user.image} alt={item.user?.title || 'Игрок'} class="predictions__avatar">
												{:else}
													<span class="predictions__avatar predictions__avatar--placeholder">{getInitials(item.user?.title)}</span>
												{/if}
												<span>{item.user?.title || '—'}</span>
											</div>
										</td>
										<td>{item.wins ?? 0}</td>
										<td>{item.losses ?? 0}</td>
										<td>{getNet(item)}</td>
										<td>{item.winPct ?? 0}</td>
									</tr>
								{/each}
							</tbody>
						</table>

						{#if !items.length}
							<div class="bettings-leaderboard__empty">Ставок пока нет</div>
						{/if}
					</div>
				</div>
			</div>
		</section>
	{/if}
</div>

<style>
	:host {
		display: block;
		font-family: inherit;
	}

	.bettings-leaderboard__status {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 120px;
		color: #53657b;
		text-align: center;
	}

	.bettings-leaderboard__empty {
		padding: 20px 16px;
		color: #6b7a90;
		font-size: 14px;
		text-align: center;
	}

	.predictions__avatar--placeholder {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		color: #53657b;
		font-size: 11px;
		font-weight: 700;
		letter-spacing: 0.02em;
	}
</style>
